import Reveal from "@/components/ui/Reveal";

/**
 * Mission (#mission): a black band that opens /about, so its heading is the page's h1. A centred
 * label and heading over a centred column of left-aligned paragraphs.
 */
export default function AboutMission() {
  return (
    <section
      id="mission"
      aria-labelledby="mission-heading"
      className="scroll-mt-20 bg-mkt-inarax-black px-margin-mobile md:px-margin-desktop py-size-xl"
    >
      <div className="max-w-[1440px] mx-auto">
        <Reveal className="max-w-4xl mx-auto text-center">
          <span className="font-label-md text-label-md uppercase tracking-widest text-mkt-on-primary-container">
            About inaraX &mdash; Our mission
          </span>
          <h1
            id="mission-heading"
            className="mt-size-sm font-display-lg text-[clamp(28px,3vw,44px)] leading-[1.15] tracking-[-0.02em] font-bold text-white text-balance"
          >
            AI is changing work. We&rsquo;re helping people keep pace.
          </h1>
        </Reveal>

        <Reveal
          delayMs={100}
          className="mt-size-lg max-w-3xl mx-auto flex flex-col gap-size-sm text-left font-body-lg text-body-lg text-white"
        >
          <p>
            AI is transforming how organizations work, but technology alone doesn&rsquo;t create transformation.
            People do.
          </p>
          <p>
            We exist to help organizations build the AI capabilities their people need to thrive by making learning
            more personal, practical, and connected to the work they actually do.
          </p>
          <p>
            inaraX brings together AI-powered personalization, industry expertise, and practical learning to help
            every learner develop the skills that matter to their role, goals, and organization.
          </p>
          <p className="font-bold">
            Because the future of work will be shaped by AI. But it will still be built by people.
          </p>
          <p>We&rsquo;re building the learning infrastructure to bring those two together.</p>
        </Reveal>
      </div>
    </section>
  );
}
